var _path, _rect, _rect2, _rect3, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 304,
    viewBox: "0 0 390 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2a2 2 0 0 1 2-2h126a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H22a2 2 0 0 1-2-2V2zM326 2a2 2 0 0 1 2-2h40a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-40a2 2 0 0 1-2-2V2z",
    fill: "#EEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 350,
    height: 40,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 87,
    width: 175,
    height: 175,
    rx: 6,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 199,
    y: 87,
    width: 175,
    height: 175,
    rx: 6,
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vcqmmdpf7a)",
    d: "M0 0h390v390H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vcqmmdpf7a",
    x1: 195,
    y1: -137.386,
    x2: 195,
    y2: 255.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAb);
export default __webpack_public_path__ + "static/media/EmptyAb.f78dd415246b933184a76208a7587db8.svg";
export { ForwardRef as ReactComponent };